<template>
  <button class="editor-close-button" @click="closeEditor">
    ✖️
  </button>
</template>

<script>
export default {
  name: "EditorCloseButton",
  props: {
    onClose: {
      type: Function,
      required: true,
    },
  },
  methods: {
    closeEditor() {
      this.onClose();
    },
  },
};
</script>

<style scoped>
.editor-close-button {
  position: fixed;
  top: 0;
  right: 0;
  background-color: var(--my-white);
  color: white;
  border: none;
  width: 60px;
  height: 60px;
  font-size: 40px;
  cursor: pointer;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
}
.editor-close-button:hover {
  background-color: var(--my-accent);
}
</style>
